// Back to top button logic
;(() => {
  const onReady = (fn) => {
    if (document.readyState === `loading`) {
      document.addEventListener(`DOMContentLoaded`, fn, { once: true })
    } else {
      fn()
    }
  }

  onReady(() => {
    const btn = document.querySelector(`.back-to-top`)
    if (!btn) return

    let ticking = false
    const threshold = 300

    const update = () => {
      ticking = false
      const y = window.scrollY || window.pageYOffset
      if (y > threshold) {
        btn.classList.add(`is-visible`)
      } else {
        btn.classList.remove(`is-visible`)
      }
    }

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update)
        ticking = true
      }
    }

    window.addEventListener(`scroll`, onScroll, { passive: true })
    // Initialize state in case page loads scrolled
    update()

    btn.addEventListener(`click`, (e) => {
      e.preventDefault()
      try {
        window.scrollTo({ top: 0, behavior: `smooth` })
      } catch (_) {
        // Fallback
        window.scrollTo(0, 0)
      }
    })
  })
})()
